__turbopack_context__.v({
  "wrapper": "button-group-module__0UxAka__wrapper",
});
